import { useAuth0 } from "@auth0/auth0-react";

interface LoginButtonProps {
  className?: string;
}

function LoginButton({ className = "" }: LoginButtonProps) {
  const { loginWithRedirect, isLoading } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      appState: { returnTo: "/dashboard" },
    });
  };

  return (
    <button
      onClick={handleLogin}
      disabled={isLoading}
      className={`btn-primary ${className}`}
    >
      {isLoading ? "Loading..." : "Sign In"}
    </button>
  );
}

export default LoginButton;

